import { createFileRoute } from '@tanstack/react-router'
import { ReceiptPrintPage } from '../../../../features/sales/receipt-print-page'
import { voucherPrintSearchSchema } from '../../../../features/sales/search'

export const Route = createFileRoute('/_app/receipts/$receiptId/print')({
  staticData: { crumb: 'receiptPrint' },
  validateSearch: voucherPrintSearchSchema,
  component: ReceiptPrintPage,
})
